export default __webpack_public_path__ + "static/media/ill-information.da6a3dd9.svg";